module.exports = __webpack_public_path__ + "static/Tax_img3@2x.1fac4ae5.png";